<asset-map [assets]='visibleAssets()' [mode]='mode()' (assetClicked)='followAsset($event)'
           (userInteract)="stopFollowing()"
           [style.height]="minimised() ? '51px' : '389px'">
    <div class="map-actions">
        <button matButton="filled" class="btn-secondary" (click)="toggleMinimised()">
            <mat-icon>remove_red_eye</mat-icon>
            @if (!minimised()) {
                {{ 'home.minimise_map' | transloco }}
            } @else {
                {{ 'home.show_full_map' | transloco }}
            }
        </button>
        @if (!minimised() && mode().type !== 'OVERVIEW') {
            <button matButton="filled" class="btn-secondary" (click)="overview()">
                <mat-icon>undo</mat-icon>
                {{ 'home.show_all_assets' | transloco }}
            </button>
        }
    </div>
</asset-map>
@if (selected(); as selected) {
    <loren-map-details-popup [asset]="selected" (closed)="stopFollowing()"/>
}